// import {
//   Modal,
//   ModalOverlay,
//   ModalContent,
//   ModalHeader,
//   ModalFooter,
//   ModalBody,
//   ModalCloseButton,
//   Button,
//   Checkbox,
//   Stack,
// } from "@chakra-ui/react";
// import { PeToolsStyles } from "../clientstyles/PeToolStyles";

// function PeTools(props) {
//   var selectedTools = [];

//   function storedatainLocalstorage() {

//   }
//   const allPeTools = [
//     {
//       name: "punc",
//       text: "Punctuation at end of captions.",
//       regex: [/\\caption\{(.*?)\}/g, /(.*)(?<!\.})$/g],
//     },
//     { name: "zeros", text: "Find leading zeros.", regex: [/(^0+\d+| 0+\d+)/g] },
//     { name: "probability", text: "Change probability casing.", regex: [] },
//     {
//       name: "number_to_words",
//       text: "Single digit number to words.",
//       regex: [/ (\d \w+|0\d \w+)/g],
//     },
//     {
//       name: "matching_quotes",
//       text: "Find Quotes matching.",
//       regex: [/'(.*)?'/g, /('{1})/g],
//     },
//     {
//       name: "en_dash",
//       text: "En dash in ranges.",
//       regex: [/(\d+ ?(-) ?\d+)/g],
//     },
//     { name: "et_al", text: "et al. in Italics.", regex: [/et al\./g] },
//   ];

//   const updateSelectedTools = function (checked, data) {
//     console.log(data);
//     if (checked) {
//       selectedTools.push(data);
//     } else {
//       selectedTools = selectedTools.filter(function (el) {
//         return el.name !== data.name;
//       });
//     }
//   };

//   console.log("the selected Tools are:", selectedTools, props.projectid);

//   return (
//     <Modal onClose={props.onClose} isOpen={props.isOpen} isCentered>
//       <ModalOverlay />
//       <ModalContent>
//         <ModalHeader>Pre-Editing Tools</ModalHeader>
//         <ModalCloseButton />
//         <ModalBody>
//           {/* <Stack>
//            {allPeTools.map((i, j) => (
//               <Checkbox
//                 onChange={(e) => updateSelectedTools(e.target.checked, i)}
//                 key={i.name}
//               >
//                 {i.text}
//               </Checkbox>
//             ))} 
//           </Stack> */}
//           <Stack>
//             {Object.keys(PeToolsStyles).map((key) => {
//               // Access the actual tool object using the key
//               const tool = PeToolsStyles[key];

//               return (
//                 <Checkbox
//                   onChange={(e) => updateSelectedTools(e.target.checked, tool)}
//                   key={key}
//                 >
//                   {tool.name} {/* This will now show "Caption Punctuation", etc. */}
//                 </Checkbox>
//               );
//             })}
//           </Stack>
//         </ModalBody>
//         <ModalFooter>
//           <Button
//             onClick={() => {
//               props.processTools(selectedTools);
//               storedatainLocalstorage(selectedTools);
//               props.onClose();
//             }}
//             mx={2}
//             bg="var(--btn-bg)"
//             color="var(--btn-text)"
//             _hover={{ bg: "var(--btn-hover)" }}
//           >
//             Submit
//           </Button>
//           <Button onClick={props.onClose}>Close</Button>
//         </ModalFooter>
//       </ModalContent>
//     </Modal>
//   );
// }
// export default PeTools;

import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Checkbox,
  Stack,
} from "@chakra-ui/react";
import { connect } from "react-redux"; // Import connect
import { PeToolsStyles } from "../clientstyles/PeToolStyles";
import { forceClearAll } from "./AutoSuggestion";

function PeTools(props) {
  const [selectedToolKeys, setSelectedToolKeys] = useState([]);

  const PE_STORAGE_KEY = "peTools";
  const CE_STORAGE_KEY = "ceTools";
  const STYLING_STORAGE_KEY = "stylingTools";

  useEffect(() => {
    if (!props.isOpen) return;

    const savedData = localStorage.getItem(PE_STORAGE_KEY);
    if (savedData) {
      try {
        const parsed = JSON.parse(savedData);
        const projectData = parsed.projects?.find(p => p.id === props.projectid);
        if (projectData && projectData.styles) {
          setSelectedToolKeys(projectData.styles);
        } else {
          setSelectedToolKeys([]);
        }
      } catch (e) {
        console.error("Failed to parse local storage", e);
      }
    }
  }, [props.projectid, props.isOpen]);

  function storedatainLocalstorage(keys) {
    const existingData = localStorage.getItem(PE_STORAGE_KEY);
    let peData = { activestatus: true, projects: [] };

    if (existingData) {
      try {
        peData = JSON.parse(existingData);
      } catch (e) {
        console.error("Error parsing existing PE data");
      }
    }

    peData.activestatus = true;
    const projectIndex = peData.projects.findIndex(p => p.id === props.projectid);
    if (projectIndex > -1) {
      peData.projects[projectIndex].styles = keys;
    } else {
      peData.projects.push({ id: props.projectid, styles: keys });
    }

    localStorage.setItem(PE_STORAGE_KEY, JSON.stringify(peData));

    // Deactivate Others
    [CE_STORAGE_KEY, STYLING_STORAGE_KEY].forEach(key => {
      const saved = localStorage.getItem(key);
      if (saved) {
        try {
          const data = JSON.parse(saved);
          data.activestatus = false;
          localStorage.setItem(key, JSON.stringify(data));
        } catch (e) { console.error(`Error deactivating ${key}`); }
      }
    });
  }

  const updateSelectedTools = (checked, key) => {
    if (checked) {
      setSelectedToolKeys((prev) => [...prev, key]);
    } else {
      setSelectedToolKeys((prev) => prev.filter((k) => k !== key));
    }
  };

  const handleSubmit = () => {
    if (selectedToolKeys.length === 0) {
      props.toast({ title: "Select any tool", status: "error", duration: 1000 });
      return;
    }

    // 1. Update LocalStorage
    storedatainLocalstorage(selectedToolKeys);

    // 2. Trigger Redux Actions (Matching Styling.js logic)
    props.clearautosuggestion();
    props.clearAutoSuggestionRejects();
    props.editToolRejected();
    
    // Trigger the suggestion engine refresh
    props.triggerToolStyles(); 

    // 3. Clear Editor Markers
    const editor = props.ace?.current?.editor;
    if (editor) {
      props.autoSuggestions?.forEach(item => {
        if (item.markerId) editor.session.removeMarker(item.markerId);
      });
      forceClearAll(editor);
    }

    // 4. UI State Updates
    props.showsuggestion();
    props.showautosuggestion();
    
    props.onClose();
  };

  return (
    <Modal onClose={props.onClose} isOpen={props.isOpen} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Pre-Editing Tools</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Stack>
            {Object.keys(PeToolsStyles).map((key) => {
              const tool = PeToolsStyles[key];
              return (
                <Checkbox
                  onChange={(e) => updateSelectedTools(e.target.checked, key)}
                  key={key}
                  isChecked={selectedToolKeys.includes(key)}
                >
                  {tool.name}
                </Checkbox>
              );
            })}
          </Stack>
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={handleSubmit}
            mx={2}
            bg="var(--btn-bg)"
            color="var(--btn-text)"
            _hover={{ bg: "var(--btn-hover)" }}
          >
            Submit
          </Button>
          <Button onClick={props.onClose}>Close</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

// Map State and Dispatch to props
const mapStateToProps = (state) => ({
  autoSuggestions: state.autoSuggestion.suggestions,
});

const mapDispatchToProps = (dispatch) => ({
  triggerToolStyles: () => dispatch({ type: "triggerToolStyles" }),
  clearautosuggestion: () => dispatch({ type: "clearAutoSuggestion" }),
  clearAutoSuggestionRejects: () => dispatch({ type: "EmptyAutoSuggestionReject" }),
  editToolRejected: () => dispatch({ type: "EmptyReject", payload: [] }),
  showsuggestion: () => dispatch({ type: "showsuggestion" }),
  showautosuggestion: () => dispatch({ type: "toggleautosuggestion" }),
});

export default connect(mapStateToProps, mapDispatchToProps)(PeTools);